module.exports.wrapRootElement = require("./gatsby-ssr").wrapRootElement